(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', function(event) {
    const chip = event.target.closest('.js-search-chip');
    if (!chip) return;

    event.preventDefault();
    event.stopPropagation();

    const term = (chip.dataset.searchTerm || chip.textContent || '').trim();
    if (!term) return;

    const searchToggle =
      document.querySelector('[data-open-search]') ||
      document.querySelector('[data-action="open-search"]') ||
      document.querySelector('.header__icon--search') ||
      document.querySelector('button[aria-label="Search"]') ||
      document.querySelector('a[aria-label="Search"]');

    if (searchToggle) {
      searchToggle.click();

      function tryFillSearch() {
        const input =
          document.querySelector('.predictive-search__input') ||
          document.querySelector('.search-modal input[type="search"]') ||
          document.querySelector('form[action="/search"] input[type="search"]');

        if (!input) return false;

        input.focus();
        input.value = term;
        input.dispatchEvent(new Event('input', { bubbles: true }));

        return true;
      }

      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (tryFillSearch() || attempts > 15) {
          clearInterval(interval);
        }
      }, 80);

      return;
    }

    const searchUrl = `/search?q=${encodeURIComponent(term)}&options[prefix]=last`;
    window.location.href = searchUrl;
  });

  document.addEventListener('DOMContentLoaded', function () {
    const allBadgeGroups = document.querySelectorAll('.variant-card__labels');

    allBadgeGroups.forEach((group) => {
      const productId = group.getAttribute('data-product-id');
      const viewMoreBtn = document.querySelector('.variant-card__view-more[data-product-id="' + productId + '"]');

      if (!viewMoreBtn) return;

      const collapsedHeight = 56;

      const updateButtonVisibility = () => {
        if (group.scrollHeight > collapsedHeight + 2) {
          viewMoreBtn.classList.add('show');
        } else {
          viewMoreBtn.classList.remove('show');
        }
      };

      updateButtonVisibility();

      viewMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (group.classList.contains('expanded')) {
          group.classList.remove('expanded');
          viewMoreBtn.textContent = 'View more';
        } else {
          group.classList.add('expanded');
          viewMoreBtn.textContent = 'View less';
        }
      });
    });

    document.querySelectorAll('.js-badge-link').forEach((badge) => {
      badge.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const href = badge.getAttribute('data-href');
        if (href) {
          window.location.href = href;
        }
      });
    });
  });


      const productGrid = document.getElementById('CollectionProductGrid');
    let loadMoreTrigger = document.querySelector('.collection-load-more');
    let isLoadingMore = false;

    const setupInfiniteScroll = () => {
      if (!productGrid || !loadMoreTrigger) return;

      const observer = new IntersectionObserver(
        async (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting || isLoadingMore) return;

          const nextUrl = loadMoreTrigger.getAttribute('data-next-url');
          if (!nextUrl) return;

          isLoadingMore = true;
          loadMoreTrigger.classList.add('is-loading');

          try {
            const response = await fetch(nextUrl, { credentials: 'same-origin' });
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newItems = doc.querySelectorAll('#CollectionProductGrid .product-grid__item');
            newItems.forEach((item) => {
              productGrid.appendChild(item);
            });

            const newTrigger = doc.querySelector('.collection-load-more');

            if (newTrigger && newTrigger.getAttribute('data-next-url')) {
              loadMoreTrigger.setAttribute('data-next-url', newTrigger.getAttribute('data-next-url'));
              loadMoreTrigger.classList.remove('is-loading');
            } else {
              loadMoreTrigger.remove();
              loadMoreTrigger = null;
              observer.disconnect();
            }

            // re-bind view more buttons for newly appended products
            const allBadgeGroups = document.querySelectorAll('.variant-card__labels');

            allBadgeGroups.forEach((group) => {
              if (group.hasAttribute('data-view-more-bound')) return;
              group.setAttribute('data-view-more-bound', 'true');

              const productId = group.getAttribute('data-product-id');
              const viewMoreBtn = document.querySelector('.variant-card__view-more[data-product-id="' + productId + '"]');

              if (!viewMoreBtn) return;

              const collapsedHeight = 56;

              const updateButtonVisibility = () => {
                if (group.scrollHeight > collapsedHeight + 2) {
                  viewMoreBtn.classList.add('show');
                } else {
                  viewMoreBtn.classList.remove('show');
                }
              };

              updateButtonVisibility();

              viewMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (group.classList.contains('expanded')) {
                  group.classList.remove('expanded');
                  viewMoreBtn.textContent = 'View more';
                } else {
                  group.classList.add('expanded');
                  viewMoreBtn.textContent = 'View less';
                }
              });
            });

            document.querySelectorAll('.js-badge-link').forEach((badge) => {
              if (badge.hasAttribute('data-badge-bound')) return;
              badge.setAttribute('data-badge-bound', 'true');

              badge.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const href = badge.getAttribute('data-href');
                if (href) {
                  window.location.href = href;
                }
              });
            });
          } catch (error) {
            console.error('Error loading more products:', error);
          } finally {
            isLoadingMore = false;
          }
        },
        {
          rootMargin: '300px 0px'
        }
      );

      observer.observe(loadMoreTrigger);
    };

    setupInfiniteScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const chip = document.getElementById('nk-variant-chip-{{ section.id }}');
  const url = new URL(window.location.href);

// 1. Try current URL ?p=
let mode = url.searchParams.get('p'); // "digital" | "physical" | null

// 2. If no ?p= here, try to inherit from previous page (?p= on referrer)
if (!mode && document.referrer) {
  try {
    const ref = new URL(document.referrer);
    if (ref.hostname === url.hostname) {
      const refMode = ref.searchParams.get('p');
      if (refMode === 'digital' || refMode === 'physical') {
        mode = refMode;
      }
    }
  } catch (e) {
    // ignore invalid referrer
  }
}

if (!mode) {
    mode = 'physical';
  }

// 3. If a specific variant is in URL, never override it
if (url.searchParams.get('variant')) {
  syncChipFromCurrent();
  return;
}


  // ---------- Helpers ----------
  const norm = (str) =>
    (str || '')
      .toString()
      .toLowerCase()
      .replace(/[_-]/g, ' ')
      .trim();

  const setChip = (label) => {
    if (!chip) return;
    const v = (label || '').trim();
    chip.hidden = !v || v === 'Default Title';
    if (!chip.hidden) chip.textContent = v;
  };

  const getVariantSelect = () => {
    // try common patterns, not limited to .product-details
    return (
      document.querySelector('form[action*="/cart/add"] select[name="id"]') ||
      document.querySelector('select[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]')
    );
  };

  const getAllVariantOptions = (select) => {
    if (!select || !select.options) return [];
    return Array.from(select.options);
  };

  const pickVariantIdForMode = (select) => {
    if (!mode || !select) return null;
    const options = getAllVariantOptions(select);
    if (!options.length) return null;

    if (mode === 'physical') {
      const primary = ['physical'];
      const secondary = ['softcover', 'soft cover'];

      // 1) physical + softcover
      for (const o of options) {
        const label = norm(o.getAttribute('data-variant-title') || o.textContent);
        if (!label) continue;
        const hasPrimary = primary.every((t) => label.includes(t));
        const hasSecondary = secondary.some((t) => label.includes(t));
        if (hasPrimary && hasSecondary) return o.value;
      }

      // 2) any softcover
      for (const o of options) {
        const label = norm(o.getAttribute('data-variant-title') || o.textContent);
        if (!label) continue;
        if (secondary.some((t) => label.includes(t))) return o.value;
      }

      return null;
    }

    if (mode === 'digital') {
      const digitalTerms = ['digital', 'pdf', 'ebook'];

      for (const o of options) {
        const label = norm(o.getAttribute('data-variant-title') || o.textContent);
        if (!label) continue;
        if (digitalTerms.some((t) => label.includes(t))) return o.value;
      }

      return null;
    }

    return null;
  };

  const clickFormatButtonForMode = () => {
    if (!mode) return;

    // Look for visible format buttons / radios
    const candidates = Array.from(
      document.querySelectorAll(
        `
        .product-details [type="radio"],
        .product-details button,
        .product-form__input input[type="radio"],
        .product-form__input label,
        [data-product-form] input[type="radio"],
        [data-product-form] label
      `
      )
    );

    if (!candidates.length) return;

    const wantPhysical = mode === 'physical';
    const wantDigital = mode === 'digital';

    const matchScore = (text) => {
      const t = norm(text);
      if (!t) return 0;

      if (wantPhysical) {
        const hasPhys = t.includes('physical');
        const hasSoft = t.includes('softcover') || t.includes('soft cover');
        if (hasPhys && hasSoft) return 3; // best
        if (hasSoft) return 2;
        return 0;
      }

      if (wantDigital) {
        if (t.includes('digital') || t.includes('pdf') || t.includes('ebook')) return 2;
        return 0;
      }

      return 0;
    };

    let best = null;
    let bestScore = 0;

    candidates.forEach((el) => {
      let text = '';

      if (el.tagName === 'INPUT' && el.type === 'radio') {
        const lbl =
          el.closest('label') ||
          document.querySelector(`label[for="${el.id}"]`);
        text = lbl ? lbl.textContent : el.value;
      } else {
        text = el.textContent;
      }

      const score = matchScore(text);
      if (score > bestScore) {
        bestScore = score;
        best = el;
      }
    });

    if (best && bestScore > 0) {
      const targetInput =
        best.tagName === 'INPUT'
          ? best
          : best.querySelector('input[type="radio"]') || best;

      targetInput.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  function syncChipFromCurrent() {
    const select = getVariantSelect();
    if (select && select.options.length) {
      const o = select.options[select.selectedIndex];
      setChip(o?.getAttribute('data-variant-title') || o?.textContent);
    }
  }

  // ---------- Main flow ----------

  const variantSelect = getVariantSelect();
  let applied = false;

  if (variantSelect) {
    const targetId = pickVariantIdForMode(variantSelect);
    if (targetId) {
      if (variantSelect.tagName === 'SELECT') {
        variantSelect.value = targetId;
      } else {
        // non-select but has name="id"
        variantSelect.value = targetId;
      }
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      applied = true;
    }
  }

  // If no select or couldn't pick by ID, try by visible format button label
  if (!applied) {
    clickFormatButtonForMode();
  }

  // Initial chip sync
  syncChipFromCurrent();

  // Keep chip in sync on changes
  if (variantSelect) {
    variantSelect.addEventListener(
      'change',
      () => {
        const o = variantSelect.options[variantSelect.selectedIndex];
        setChip(o?.getAttribute('data-variant-title') || o?.textContent);
      },
      { capture: true }
    );
  }

  document.addEventListener('variant:change', (e) => {
    const v = e?.detail?.variant;
    if (v && typeof v.title === 'string') setChip(v.title);
  });
});

  } catch(e) { console.error(e); }
})();
})();
